<template>
  <!-- Modal de Acceso -->
  <div
    class="modal fade"
    id="loginModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="loginModal"
    data-bs-dismiss
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" v-t="'login.titulo_login'"></h5>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Cerrar"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="header-pic">
          <img src="/img/head_login.jpg" />
        </div>
        <div class="modal-body">
          <form
            class="form-signin"
            id="form-signin"
            :action="url_api + '/auth'"
            method="post"
            v-on:submit.prevent="sendForm()"
            data-vv-scope="form_login"
          >
            <span
              class="error text-danger"
              style="margin: 5px 0px"
              v-show="error_login"
              v-t="'login.cuenta_esta_activa'"
            ></span>

            <input
              type="text"
              id="inputUserLogin"
              class="form-control"
              :placeholder="$t('login.correo')"
              name="correo"
              autofocus
              v-validate="'required|email'"
              @keypress="withoutSpace($event)"
              v-model.trim="form_data.user"
              :disabled="is_send"
            />
            <span
              class="error text-danger"
              data-bs-dismiss
              v-show="errors_validate.has('form_login.correo')"
              >{{ errors_validate.first("form_login.correo") }}</span
            >

            <input
              type="password"
              id="inputPasswordLogin"
              class="form-control"
              :placeholder="$t('login.contrasena')"
              name="clave"
              v-validate="'required'"
              @keypress="withoutSpace($event)"
              v-model.trim="form_data.pass"
              :disabled="is_send"
            />
            <span
              class="error text-danger"
              v-show="errors_validate.has('form_login.clave')"
              >{{ errors_validate.first("form_login.clave") }}</span
            >
            <div class="col-md-12">
              <!-- <label class="radio-container sideleft">
                        <input type="checkbox" value="remember-me" v-model="form_data.record_me" >Recordarme
                        <span class="checkmark"></span>
                    </label> -->
            </div>

            <div class="col-md-12 cont-captcha">
              <!-- <vue-recaptcha
                ref="invisibleRecaptcha1"
                :sitekey="sit_ky"
                :loadRecaptchaScript="false"
                recaptchaScriptId="invisibleRecaptcha1"
                size="invisible"
                @verify="onCaptchaVerified"
                @expired="onExpired"
              ></vue-recaptcha> -->
            </div>

            <div class="bt-signin-box">
              <button
                class="material-btn bt_red"
                type="submit"
                :disabled="is_send"
                v-t="'boton.ingresar'"
              ></button>
            </div>
          </form>

          <div class="bt-register-box">
            {{ $t("login.notengo") }}
            <a
              href="#0"
              data-bs-toggle="modal"
              data-bs-target="#loginRegisterModal"
              data-bs-dismiss="modal"
              v-t="'login.quiero_crear'"
            ></a>
          </div>
        </div>
        <a
              class="bt_forgot"
              role="button"
              href="#0"
              data-bs-toggle="modal"
              data-bs-target="#forgotPasswordModal"
              data-bs-dismiss="modal"
              v-t="'login.forgot_pass'"
            >
            </a>

        <div class="cont_loader_login_form">
          <vue-loading
            type="spin"
            color="#d9544e"
            :size="{ width: '30px', height: '30px' }"
            v-show="validando_captcha"
          ></vue-loading>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Snackbar from "node-snackbar";
import { mapActions } from "vuex";
import * as auth_request from "../../request/auth.js";
import AuthMixins from "../../mixins/auth.js";

export default {
  props: {
    validateRecaptcha: {
      type: Function,
      default: () => {},
    },
    resetTheRecaptcha: {
      type: Function,
      default: () => {},
    },
    temp_valla: {
      type: Object,
      default: null,
    },
  },
  mixins: [AuthMixins],
  mounted() {
    $(document).ready(function () {
      $("#loginModal").on("show.bs.modal", function () {
        document.getElementById("app").style.position = "relative";
      });

      $("#loginModal").on("hidden.bs.modal", function () {
        document.getElementById("app").style.position = null;
      });
    });
  },
  data() {
    return {
      form_data: {
        user: "",
        pass: "",
        record_me: false,
      },
      is_send: false,
      url_api: window.url_api,
      error_login: window.error_login ? window.error_login : false,
      sit_ky: process.env.VUE_APP_RECAPTH_KEY_PROD,
    };
  },

  methods: {
    ...mapActions(["changueUser", "changueToken"]),
    sendForm() {
      this.$validator.validateAll("form_login").then((result) => {
        if (result) {
          this.validateRecaptcha("login");
          this.validando_captcha = true;
          this.is_send = true;
        } else {
          // Si el formulario no es valido
          this.is_send = false;
        }
      });
    },
    onCaptchaVerified(token) {
      this.validando_captcha = false;
      let vm = this;
      // Reinicia el Captcha
      vm.resetCaptcha();
      let data = new FormData();
      data.append("email", vm.form_data.user);
      data.append("password", vm.form_data.pass);
      data.append("g-recaptcha-response", token);
      // envia
      auth_request
        .postLogin(data)
        .then((response) => {
          $("#loginModal").modal("hide");
          $("body").removeClass("modal-open");
          $(".modal-backdrop").remove();
          vm.changueToken(response.data.data.token); // guarda los datos en Storage
          vm.changueUser(response.data.data.user); // obtiene los datos del usuario
          // Notificacion al usuario
          Snackbar.show({
            text: this.$t("alert.sesion_iniciada"),
            pos: "bottom-center",
            backgroundColor: "#1D0E54",
            actionTextColor: "#ee5b66",
            actionText: "<b>" + this.$t("boton.cerrar") + "</b>",
          });
          vm.form_data.user = "";
          vm.form_data.pass = "";
          vm.is_send = false;
          if (vm.temp_valla) {
            vm.$root.$emit("EventAddToList", vm.temp_valla);
            vm.$parent.resetTemp();
          }
          setTimeout(() => {
            vm.$validator.reset();
          }, 300);
        })
        .catch((err_) => {
          vm.is_send = false;
          if (err_.response.status === 401) {
            Snackbar.show({
              text: this.$t("alert.ya_activaste"),
              pos: "bottom-center",
              backgroundColor: "#ff1744",
              duration: 10000,
              actionText: "<b>" + this.$t("boton.cerrar") + "</b>",
              actionTextColor: "#fff",
            });
          } else {
            Snackbar.show({
              text: this.$t("alert.error_admin"),
              pos: "bottom-center",
              backgroundColor: "#ff1744",
              actionText: "<b>" + this.$t("boton.cerrar") + "</b>",
              actionTextColor: "#fff",
            });
          }
        });
    },
    withoutSpace: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode === 32) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    resetCaptcha() {
      this.resetTheRecaptcha();
    },
    onExpired() {},
  },
};
</script>

<style>
.grecaptcha-badge {
  display: none !important;
}

.bt_forgot {
  margin-left: 15px;
  color: red;
  font-weight: bold;
}

.bt_forgot:hover {
  color: rgb(237, 24, 24);
}
</style>

<i18n src="@/locale/modals/generic.json" />
<i18n src="@/locale/modals/login.json" />
<i18n src="@/locale/modals/alertas.json" />
